import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  stage: {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    backgroundColor: 'rgba(0,0,0,0)',
    width: 'inherit',
    minWidth: (useStylesParams) =>
      useStylesParams.expanded ? '490px' : '600px',
    '@media (min-width: 1441px)': {
      width: '100%',
      maxWidth: '40vw',
    },
  },
  stage2: {
    height: '100%',
    maxHeight: '100vh',
    width: '100%',
    paddingLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflowX: 'auto',
    overflowY: 'hidden',
    cursor: 'grab',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
